import { render, staticRenderFns } from "./DlgEditRecipient.vue?vue&type=template&id=0b6c017f&scoped=true&"
import script from "./DlgEditRecipient.vue?vue&type=script&lang=js&"
export * from "./DlgEditRecipient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6c017f",
  null
  
)

export default component.exports